'use strict';

var MESSAGE_TYPE = {
	DANGER : {
		style : 'error',
		icon : 'minus-circle',
		color : '#a94442'
	},
	WARNING : {
		style : 'warning',
		icon : 'warning',
		color : '#8a6d3b'
	},
	SUCCESS : {
		style : 'notice',
		icon : 'check',
		color : '#3c763d'
	},
	INFO : {
		style : 'notice',
		icon : 'info-circle',
		color : '#31708f'
	}
};

var ADM_EVENTS = {
	ADM_CREATE_USER : {
		id : 10,
		name : 'Crear usuario',
		enumName : 'ADM_CREATE_USER'
	},
	ADM_UPDATE_USER : {
		id : 11,
		name : 'Actualizar usuario',
		enumName : 'ADM_UPDATE_USER'
	},
	ADM_UPDATE_USER_STATUS : {
		id : 12,
		name : 'Actualizar estado de usuario',
		enumName : 'ADM_UPDATE_USER_STATUS'
	},
	ADM_CREATE_PARAMETER : {
		id : 13,
		name : 'Crear parámetro',
		enumName : 'ADM_CREATE_PARAMETER'
	},
	ADM_UPDATE_PARAMETER : {
		id : 14,
		name : 'Actualizar parámetro',
		enumName : 'ADM_UPDATE_PARAMETER'
	},
	ADM_UPDATE_PARAMETER_STATUS : {
		id : 15,
		name : 'Actualizar el estado del parámetro',
		enumName : 'ADM_UPDATE_PARAMETER_STATUS'
	},
	ADM_CREATE_CLIENT : {
		id : 16,
		name : 'Crear cliente',
		enumName : 'ADM_CREATE_CLIENT'
	},
	ADM_UPDATE_CLIENT : {
		id : 17,
		name : 'Actualizar cliente',
		enumName : 'ADM_UPDATE_CLIENT'
	},//
	ADM_REMOVE_CLIENT : {
		id : 18,
		name : 'Eliminar cliente',
		enumName : 'ADM_REMOVE_CLIENT'
	},
	ADM_ENABLE_CLIENT : {
		id : 19,
		name : 'Habilitar cliente',
		enumName : 'ADM_ENABLE_CLIENT'
	},
	ADM_DISABLE_CLIENT : {
		id : 20,
		name : 'Deshabilitar cliente',
		enumName : 'ADM_DISABLE_CLIENT'
	},
	ADM_CREATE_CONTACT : {
		id : 21,
		name : 'Crear contacto',
		enumName : 'ADM_CREATE_CONTACT'
	},
	ADM_REMOVE_CONTACT : {
		id : 22,
		name : 'Eliminar contacto',
		enumName : 'ADM_REMOVE_CONTACT'
	},
	ADM_UPDATE_CONTACT : {
		id : 23,
		name : 'Actualizar contacto',
		enumName : 'ADM_UPDATE_CONTACT'
	},
	ADM_DEFINE_MAINCONTACT : {
		id : 24,
		name : 'Definir contacto principal',
		enumName : 'ADM_DEFINE_MAINCONTACT'
	},
	ADM_DEFINE_CONTACTTOSITE : {
		id : 25,
		name : 'Definir contacto de punto',
		enumName : 'ADM_DEFINE_CONTACTTOSITE'
	},
	ADM_CREATE_CLIENTSITE : {
		id : 26,
		name : 'Crear punto',
		enumName : 'ADM_CREATE_CLIENTSITE'
	},
	ADM_REMOVE_CLIENTSITE : {
		id : 27,
		name : 'Eliminar punto',
		enumName : 'ADM_REMOVE_CLIENTSITE'
	},
	ADM_UPDATE_CLIENTSITE : {
		id : 28,
		name : 'Actualizar punto',
		enumName : 'ADM_UPDATE_CLIENTSITE'
	},
	ADM_CREATE_CLIENTAREA : {
		id : 29,
		name : 'Crear Área ',
		enumName : 'ADM_CREATE_CLIENTAREA'
	},
	ADM_UPDATE_CLIENTAREA : {
		id : 30,
		name : 'Actualizar Área',
		enumName : 'ADM_UPDATE_CLIENTAREA'
	},
	ADM_REMOVE_CLIENTAREA : {
		id : 31,
		name : 'Eliminar Área',
		enumName : 'ADM_REMOVE_CLIENTAREA'
	},
	ADM_CREATE_SAMPLE_ELEMENT : {
		id : 32,
		name : 'Crear Elemento de muestreo',
		enumName : 'ADM_CREATE_SAMPLE_ELEMENT'
	},
	ADM_UPDATE_SAMPLE_ELEMENT : {
		id : 33,
		name : 'Actualizar Elemento de muestreo',
		enumName : 'ADM_UPDATE_SAMPLE_ELEMENT'
	},
	ADM_REMOVE_SAMPLE_ELEMENT : {
		id : 34,
		name : 'Eliminar Elemento de muestreo',
		enumName : 'ADM_REMOVE_SAMPLE_ELEMENT'
	},
	ADM_CREATE_REGULATION : {
		id : 35,
		name : 'Crear normativa',
		enumName : 'ADM_CREATE_REGULATION'
	},
	ADM_DELETE_REGULATION : {
		id : 36,
		name : 'Eliminar normativa',
		enumName : 'ADM_DELETE_REGULATION'
	},
	ADM_ENABLE_REGULATION : {
		id : 37,
		name : 'Habilitar normativa',
		enumName : 'ADM_ENABLE_REGULATION'
	},
	ADM_DISABLE_REGULATION : {
		id : 38,
		name : 'Deshabilitar normativa',
		enumName : 'ADM_DISABLE_REGULATION'
	},
	ADM_UPDATE_REGULATION : {
		id : 39,
		name : 'Actualizar normativa',
		enumName : 'ADM_UPDATE_REGULATION'
	},
	ADM_CREATE_PRODUCT : {
		id : 40,
		name : 'Crear producto',
		enumName : 'ADM_CREATE_PRODUCT'
	},
	ADM_UPDATE_PRODUCT : {
		id : 41,
		name : 'Actualizar producto',
		enumName : 'ADM_UPDATE_PRODUCT'
	},
	ADM_REMOVE_PRODUCT : {
		id : 42,
		name : 'Eliminar producto',
		enumName : 'ADM_REMOVE_PRODUCT'
	},
	ADM_ASSOCIATE_REGULATIONS2PRODUCT : {
		id : 43,
		name : 'Asociar normativa a producto',
		enumName : 'ADM_ASSOCIATE_REGULATIONS2PRODUCT'
	},
	ADM_UPDATE_ASSOCIATE_REGULATIONS2PRODUCT : {
		id : 44,
		name : 'Actualizar asociación normativa - producto',
		enumName : 'ADM_UPDATE_ASSOCIATE_REGULATIONS2PRODUCT'
	},
	ADM_DESASSOCIATE_REGULATION_FOR_PRODUCT : {
		id : 45,
		name : 'Desasociar normativa de producto',
		enumName : 'ADM_DESASSOCIATE_REGULATION_FOR_PRODUCT'
	},
	ADM_CREATE_PRODUCT_CATEGORY : {
		id : 46,
		name : 'Crear categoría de producto',
		enumName : 'ADM_CREATE_PRODUCT_CATEGORY'
	},
	ADM_UPDATE_PRODUCT_CATEGORY : {
		id : 47,
		name : 'Actualizar categoría de producto',
		enumName : 'ADM_UPDATE_PRODUCT_CATEGORY'
	},
	ADM_DELETE_PRODUCT_CATEGORY : {
		id : 48,
		name : 'Eliminar categoría de producto',
		enumName : 'ADM_DELETE_PRODUCT_CATEGORY'
	},
	ADM_ADDPARENT_CATEGORIES : {
		id : 49,
		name : 'Agregar categorías padre ',
		enumName : 'ADM_ADDPARENT_CATEGORIES'
	},
	ADM_DEFINE_LEGAL_REP : {
		id : 50,
		name : 'Asignar representante legal ',
		enumName : 'ADM_DEFINE_LEGAL_REP'
	},
	ADM_UPDATE_SIGN : {
		id : 51,
		name : 'Actualizar firma de usuario',
		enumName : 'ADM_UPDATE_SIGN'
	},
	ADM_CREATE_REGULATION_ANALYSIS : {
		id : 52,
		name : 'Crear análisis de normativa',
		enumName : 'ADM_CREATE_REGULATION_ANALYSIS'
	},
	ADM_DELETE_REGULATION_ANALYSIS : {
		id : 53,
		name : 'Eliminar análisis de normativa',
		enumName : 'ADM_DELETE_REGULATION_ANALYSIS'
	},
	ADM_UPDATE_REGULATION_ANALYSIS : {
		id : 54,
		name : 'Actualizar análisis de normativa',
		enumName : 'ADM_UPDATE_REGULATION_ANALYSIS'
	},
	ADM_ENABLE_ANALYSIS : {
		id : 55,
		name : 'Habilitar análisis',
		enumName : 'ADM_ENABLE_ANALYSIS'
	},
	ADM_DISABLE_ANALYSIS : {
		id : 56,
		name : 'Deshabilitar análisis',
		enumName : 'ADM_DISABLE_ANALYSIS'
	},
	
	ADM_CREATE_ANALYSIS_TECHNIQUE : {
		id : 57,
		name : 'Crear técnica de análisis',
		enumName : 'ADM_CREATE_ANALYSIS_TECHNIQUE'
	},
	ADM_UPDATE_ANALYSIS_TECHNIQUE : {
		id : 58,
		name : 'Actualizar técnica de análisis',
		enumName : 'ADM_UPDATE_ANALYSIS_TECHNIQUE'
	},
	ADM_ENABLE_TECHNIQUE : {
		id : 59,
		name : 'Habilitar técnica',
		enumName : 'ADM_ENABLE_TECHNIQUE'
	},
	ADM_DISABLE_TECHNIQUE : {
		id : 60,
		name : 'Deshabilitar técnica',
		enumName : 'ADM_DISABLE_TECHNIQUE'
	},
	ADM_DELETE_ANALYSIS_TECHNIQUE : {
		id : 61,
		name : 'Eliminar técnica de análisis',
		enumName : 'ADM_DELETE_ANALYSIS_TECHNIQUE'
	},
	ADM_DELETE_TECHNIQUE_SAMPLINGMETHOD : {
		id : 62,
		name : 'Eliminar método de técnica',
		enumName : 'ADM_DELETE_TECHNIQUE_SAMPLINGMETHOD'
	},
	ADM_ADD_TECHNIQUE_SAMPLINGMETHOD : {
		id : 63,
		name : 'Agregar método de técnica',
		enumName : 'ADM_ADD_TECHNIQUE_SAMPLINGMETHOD'
	},
	ADM_UPDATE_TECHNIQUE_SAMPLINGMETHOD : {
		id : 64,
		name : 'Actualizar  método de técnica',
		enumName : 'ADM_UPDATE_TECHNIQUE_SAMPLINGMETHOD'
	},
	ADM_CHANGE_STATUS : {
		id : 65,
		name : 'Cambiar estado de usuario',
		enumName : 'ADM_CHANGE_STATUS'
	},
	ADM_UPDATE_ROLES : {
		id : 66,
		name : 'Actualizar roles',
		enumName : 'ADM_UPDATE_ROLES'
	},
	events : function() {
		return [this.ADM_UPDATE_ROLES, this.ADM_CHANGE_STATUS, this.ADM_UPDATE_TECHNIQUE_SAMPLINGMETHOD,this.ADM_ADD_TECHNIQUE_SAMPLINGMETHOD,this.ADM_DELETE_TECHNIQUE_SAMPLINGMETHOD,this.ADM_DELETE_ANALYSIS_TECHNIQUE,this.ADM_DISABLE_TECHNIQUE,this.ADM_ENABLE_TECHNIQUE,this.ADM_UPDATE_ANALYSIS_TECHNIQUE,this.ADM_CREATE_ANALYSIS_TECHNIQUE,
		        this.ADM_DISABLE_ANALYSIS,this.ADM_ENABLE_ANALYSIS,this.ADM_UPDATE_REGULATION_ANALYSIS,this.ADM_DELETE_REGULATION_ANALYSIS,this.ADM_CREATE_REGULATION_ANALYSIS,this.ADM_UPDATE_SIGN, this.ADM_DEFINE_LEGAL_REP,this.ADM_CREATE_PRODUCT_CATEGORY,this.ADM_UPDATE_PRODUCT_CATEGORY,
		        this.ADM_DELETE_PRODUCT_CATEGORY,this.ADM_ADDPARENT_CATEGORIES,this.ADM_DESASSOCIATE_REGULATION_FOR_PRODUCT,this.ADM_UPDATE_ASSOCIATE_REGULATIONS2PRODUCT,this.ADM_ASSOCIATE_REGULATIONS2PRODUCT,
		        this.ADM_REMOVE_PRODUCT,this.ADM_UPDATE_PRODUCT,this.ADM_CREATE_PRODUCT,this.ADM_UPDATE_REGULATION,this.ADM_DISABLE_REGULATION,this.ADM_ENABLE_REGULATION,this.ADM_DELETE_REGULATION,this.ADM_CREATE_REGULATION, this.ADM_REMOVE_SAMPLE_ELEMENT, this.ADM_UPDATE_SAMPLE_ELEMENT, 
		        this.ADM_CREATE_SAMPLE_ELEMENT, this.ADM_REMOVE_CLIENTAREA, this.ADM_UPDATE_CLIENTAREA, this.ADM_CREATE_CLIENTAREA, this.ADM_UPDATE_CLIENTSITE,this.ADM_REMOVE_CLIENTSITE,this.ADM_CREATE_CLIENTSITE,this.ADM_DEFINE_CONTACTTOSITE,this.ADM_DEFINE_MAINCONTACT,this.ADM_UPDATE_CONTACT,
		        this.ADM_REMOVE_CONTACT,this.ADM_CREATE_CONTACT,this.ADM_DISABLE_CLIENT,this.ADM_ENABLE_CLIENT,this.ADM_REMOVE_CLIENT, this.ADM_UPDATE_CLIENT , this.ADM_CREATE_CLIENT , this.ADM_CREATE_USER, this.ADM_UPDATE_USER, this.ADM_UPDATE_USER_STATUS, this.ADM_CREATE_PARAMETER, this.ADM_UPDATE_PARAMETER, this.ADM_UPDATE_PARAMETER_STATUS ];
	}

};

var MODULES = {
	SYS : {
		id : 0,
		name : 'SISTEMA',
		enumName : 'SYS'
	},
	ADMIN : {
		id : 1,
		name : 'ADMINISTRACIÓN',
		enumName : 'ADMIN',
		events : ADM_EVENTS.events()
	},
	values : function() {
		return [ this.SYS, this.ADMIN ];
	}
};

var OPERATION_TYPE = {
	SUCESSFULL : 1,
	ERROR : 0
};

var ROLE_TYPE = {
	SYSTEM : {
		id : 0,
		code : 'sys',
		name : 'Sistema'
	},
	ADMIN : {
		id : 1,
		code : 'admin',
		name : 'Administrador'
	},
	COMMERCIAL_MANAGER : {
		id : 2,
		code : 'commercial-manager',
		name : 'Gerente Comercial'
	},
	PROGRAMMING_COORDINATOR : {
		id : 3,
		code : 'programming-coordinator',
		name : 'Coordinador de programación'
	},
	SAMPLES_PROFESSIONAL : {
		id : 4,
		code : 'samples-professional',
		name : 'Profesional de muestras'
	},
	SAMPLE_RECEIVER : {
		id : 5,
		code : 'sample-receiver',
		name : 'Receptor de muestras'
	},
	LABORATORY_PROFESSIONAL : {
		id : 6,
		code : 'laboratory-professional',
		name : 'Profesional de Laboratorio'
	},
	TECHNICAL_PROFESSIONAL : {
		id : 7,
		code : 'technical-professional',
		name : 'Profesional de Técnico'
	},
	CLIENT : {
		id : 8,
		code : 'client',
		name : 'Cliente'
	},
	ACCOUNTING : {
		id : 9,
		code : 'accounting',
		name : 'Contabilidad'
	},

	values : function() {
		return [ this.SYSTEM, this.ADMIN, this.COMMERCIAL_MANAGER, this.PROGRAMMING_COORDINATOR, this.SAMPLES_PROFESSIONAL, this.SAMPLE_RECEIVER, this.LABORATORY_PROFESSIONAL, this.TECHNICAL_PROFESSIONAL,
				this.CLIENT, this.ACCOUNTING ];
	},
	codes : function() {
		return [ this.SYSTEM.code, this.ADMIN.code, this.COMMERCIAL_MANAGER.code, this.PROGRAMMING_COORDINATOR.code, this.SAMPLES_PROFESSIONAL.code, this.SAMPLE_RECEIVER.code, this.LABORATORY_PROFESSIONAL.code,
				this.TECHNICAL_PROFESSIONAL.code, this.CLIENT.code, this.ACCOUNTING.code ];
	},
	codesExceptClient : function() {
		return [ this.SYSTEM.code, this.ADMIN.code, this.COMMERCIAL_MANAGER.code, this.PROGRAMMING_COORDINATOR.code, this.SAMPLES_PROFESSIONAL.code, this.SAMPLE_RECEIVER.code, this.LABORATORY_PROFESSIONAL.code,
				this.TECHNICAL_PROFESSIONAL.code ];
	},
	names : function() {
		return [ this.SYSTEM.name, this.ADMIN.name, this.COMMERCIAL_MANAGER.name, this.PROGRAMMING_COORDINATOR.name, this.SAMPLES_PROFESSIONAL.name, this.SAMPLE_RECEIVER.name, this.LABORATORY_PROFESSIONAL.name,
				this.TECHNICAL_PROFESSIONAL.name, this.CLIENT.name, , this.ACCOUNTING.name ];
	}
};

var getRoleTypeByName = function(name) {
	return ROLE_TYPE.values().find(function(p) {
		return p.name.toUpperCase() == name.toUpperCase();
	})
}

var PARAMETER_CATEGORY = {
	GENERAL : {
		id : 1,
		name : 'Generales',
		enumName : 'GENERAL'
	},
	LOCATION : {
		id : 2,
		name : 'Ubicación',
		enumName : 'LOCATION'
	},
	SAMPLING : {
		id : 3,
		name : 'Muestreo',
		enumName : 'SAMPLING'
	},
	values : function() {
		return [ this.GENERAL, this.LOCATION, this.SAMPLING ];
	}
};

var PARAMETER_CATEGORY = {
	GENERAL : {
		id : 1,
		name : 'Generales',
		enumName : 'GENERAL'
	},
	LOCATION : {
		id : 2,
		name : 'Ubicación',
		enumName : 'LOCATION'
	},
	SAMPLING : {
		id : 3,
		name : 'Muestreo',
		enumName : 'SAMPLING'
	},
	values : function() {
		return [ this.GENERAL, this.LOCATION, this.SAMPLING ];
	}
};

var PARAMETER_TYPE = {
	COUNTRY : {
		id : 1,
		name : 'País',
		category : PARAMETER_CATEGORY.LOCATION,
		enumName : 'COUNTRY'
	},
	CITY : {
		id : 2,
		name : 'Ciudad',
		category : PARAMETER_CATEGORY.LOCATION,
		enumName : 'CITY'
	},
	ZONE : {
		id : 3,
		name : 'Zona',
		category : PARAMETER_CATEGORY.LOCATION,
		enumName : 'ZONE'
	},
	AREA_TYPE : {
		id : 4,
		name : 'Tipo de Área',
		category : PARAMETER_CATEGORY.LOCATION,
		enumName : 'AREA_TYPE'
	},
	IDENTIFICATION_TYPE : {
		id : 5,
		name : 'Tipo de Identificación',
		category : PARAMETER_CATEGORY.GENERAL,
		enumName : 'IDENTIFICATION_TYPE'
	},
	REGULATION_TYPE : {
		id : 6,
		name : 'Tipo de Normativa',
		category : PARAMETER_CATEGORY.GENERAL,
		enumName : 'REGULATION_TYPE'
	},
	UNITS : {
		id : 8,
		name : 'Unidades',
		category : PARAMETER_CATEGORY.GENERAL,
		enumName : 'UNITS'
	},
	ANALYSIS_TYPE : {
		id : 9,
		name : 'Tipo de Análisis',
		category : PARAMETER_CATEGORY.SAMPLING,
		enumName : 'ANALYSIS_TYPE'
	},
	MAIL_LIST_REPORTSEND : {
		id : 10,
		name : 'Notificación enviar Informe',
		category : PARAMETER_CATEGORY.SAMPLING,
		enumName : 'MAIL_LIST_REPORTSEND'
	},
	NONCONFORMING_SAMPLE_TYPE : {
		id : 11,
		name : 'Tipo de no conformidad en la muestra',
		category : PARAMETER_CATEGORY.SAMPLING,
		enumName : 'NONCONFORMING_SAMPLE_TYPE'
	},
	values : function() {
		return [ this.COUNTRY, this.CITY, this.ZONE, this.AREA_TYPE, this.IDENTIFICATION_TYPE, this.REGULATION_TYPE, this.UNITS, this.ANALYSIS_TYPE, this.MAIL_LIST_REPORTSEND, this.NONCONFORMING_SAMPLE_TYPE ];
	}
};

var SAMPLES_ELEMENT_TYPE = {
	PARTICULARES : {
		id : 1,
		name : 'Particulares',
		enumName : 'PARTICULARES'
	},
	GENERALES : {
		id : 2,
		name : 'Generales',
		enumName : 'GENERALES'
	},
	values : function() {
		return [ this.PARTICULARES, this.GENERALES ];
	}
};

var PRODUCTION_ARRIVAL_TYPE = {
	ARRIVAL_DATE : {
		id : 0,
		name : 'Fecha de llegada',
		enumName : 'ARRIVAL_DATE',
		value : false
	},
	PRODUCTION_DATE : {
		id : 1,
		name : 'Fecha de producción',
		enumName : 'PRODUCTION_DATE',
		value : true

	},
	values : function() {
		return [ this.ARRIVAL_DATE, this.PRODUCTION_DATE ];
	}
};

var TECHNIQUE_TYPE = {
	PRESENT_LACK : {
		id : 1,
		name : 'Presencia/Ausencia',
		enumName : 'PRESENT_LACK'
	},
	RANGE : {
		id : 2,
		name : 'Rango',
		enumName : 'RANGE'
	},
	UPPER_LIMIT : {
		id : 3,
		name : 'Límite superior',
		enumName : 'UPPER_LIMIT'
	},
	LOWER_LIMIT : {
		id : 4,
		name : 'Límite inferior',
		enumName : 'LOWER_LIMIT'
	},
	values : function() {
		return [ this.PRESENT_LACK, this.RANGE, this.UPPER_LIMIT, this.LOWER_LIMIT ];
	}
};

var PRESENCE_ABSENCE_LIMIT = {
	ABSENCE : {
		id : 0,
		name : 'Ausencia',
		enumName : 'ABSENCE'
	},
	PRESENCE : {
		id : 1,
		name : 'Presencia',
		enumName : 'PRESENCE'
	},
	values : function() {
		return [ this.ABSENCE, this.PRESENCE ];
	}
};

var PLAN_SAMPLING_STATE = {
	EDITION : {
		id : 1,
		name : 'Edición',
		enumName : 'EDITION',
		className : 'stateEditon'
	},
	PROGRESS : {
		id : 2,
		name : 'Ejecución',
		enumName : 'PROGRESS',
		className : 'stateProgress'
	},
	ANNUL : {
		id : -1,
		name : 'Anulado',
		enumName : 'ANNUL',
		className : 'stateAnnul'
	},
	FINISHED : {
		id : 0,
		name : 'Terminado',
		enumName : 'FINISHED',
		className : 'stateFinished'
	},
	values : function() {
		return [ this.EDITION, this.PROGRESS, this.ANNUL, this.FINISHED ];
	}
};

var PLAN_SAMPLING_EVENT = {
	CREATE : {
		id : 1,
		name : 'Creado',
		enumName : 'CREATE',
		className : 'eventPlanCreate',
		icon : 'fa-snowflake-o'
	},
	EDIT : {
		id : 2,
		name : 'Editado',
		enumName : 'EDIT',
		className : 'eventPlanEdit',
		icon : 'fa-pencil-square-o'
	},
	START : {
		id : 3,
		name : 'Iniciado',
		enumName : 'START',
		className : 'eventPlanStart',
		icon : 'fa-play'
	},
	CANCEL : {
		id : 4,
		name : 'Cancelado',
		enumName : 'CANCEL',
		className : 'eventPlanCancel',
		icon : 'fa-times-circle-o'
	},
	FINISHED : {
		id : 5,
		name : 'Finalizado',
		enumName : 'FINISHED',
		className : 'eventPlanFinished',
		icon : 'fa-check-circle'
	},
	ADD_SAMPLING : {
		id : 6,
		name : 'Adiciona Muestreo',
		enumName : 'ADD_SAMPLING',
		className : 'eventPlanAddSampling',
		icon : 'fa-plus-circle'
	},
	UPDATE_SAMPLING : {
		id : 8,
		name : 'Actualizar Muestreo',
		enumName : 'UPDATE_SAMPLING',
		className : 'stateProgress',
		icon : 'fa fa-pencil-square-o'
	},
	CLONE : {
		id : 7,
		name : 'Clonado',
		enumName : 'CLONE',
		className : 'eventPlanClone',
		icon : 'fa-clone'
	},
	values : function() {
		return [ this.CREATE, this.EDIT, this.START, this.CANCEL, this.FINISHED, this.ADD_SAMPLING, this.UPDATE_SAMPLING, this.CLONE ];
	}
};

var SAMPLE_INTERPRET_RESULT = {
	FULFIL : {
		id : 1,
		name : 'Cumple',
		enumName : 'FULFIL'
	},
	FAIL : {
		id : 2,
		name : 'No Cumple',
		enumName : 'FAIL'
	},
	NOT_APPLY : {
		id : 3,
		name : 'No aplica',
		enumName : 'NOT_APPLY'
	},
	values : function() {
		return [ this.FULFIL, this.FAIL, this.NOT_APPLY ];
	}
};

var SAMPLE_STATE = {
	NOT_CONFORM : {
		id : -2,
		name : 'No Conforme',
		enumName : 'NOT_CONFORM',
		className : 'stateNotconform'
	},
	NOT_TAKEN : {
		id : -3,
		name : 'No tomada',
		enumName : 'NOT_TAKEN',
		className : 'stateNottaken'
	},
	CANCELED : {
		id : -1,
		name : 'Cancelada',
		enumName : 'CANCELED',
		className : 'stateCanceled'
	},
	REPORTED : {
		id : 0,
		name : 'Reportada/Finalizada',
		enumName : 'REPORTED',
		className : 'stateReported'
	},
	WAITING_FOR_SCHEDULE : {
		id : 1,
		name : 'En espera de programación',
		enumName : 'WAITING_FOR_SCHEDULE',
		className : 'stateWaitingForSchedule'
	},
	SCHEDULED : {
		id : 2,
		name : 'Programada',
		enumName : 'SCHEDULED',
		className : 'stateScheduled'
	},
	ASIGNED : {
		id : 3,
		name : 'Asignada',
		enumName : 'ASIGNED',
		className : 'stateAsigned'
	},
	SAMPLE_ELEMENT_CHECKED : {
		id : 4,
		name : 'Esperando visita',
		enumName : 'SAMPLE_ELEMENT_CHECKED',
		className : 'stateSampleElementChecked'
	},
	TAKEN_NOT_SIGNED : {
		id : 5,
		name : 'Tomada no firmada',
		enumName : 'TAKEN_NOT_SIGNED',
		className : 'stateTakenNotSigned'
	},
	TAKEN : {
		id : 6,
		name : 'Tomada',
		enumName : 'TAKEN',
		className : 'stateTaken'
	},
	ADMITED : {
		id : 7,
		name : 'Admitida',
		enumName : 'ADMITED',
		className : 'stateAdmited'
	},
	ANALYZING : {
		id : 8,
		name : 'Analizando',
		enumName : 'ANALYZING',
		className : 'stateAnalyzing'
	},
	ANALYZED : {
		id : 9,
		name : 'Analizada',
		enumName : 'ANALYZED',
		className : 'stateAnalized'
	},
	values : function() {
		return [ this.CANCELED, this.WAITING_FOR_SCHEDULE, this.SCHEDULED, this.ASIGNED, this.SAMPLE_ELEMENT_CHECKED, 
			this.TAKEN_NOT_SIGNED, this.TAKEN, this.NOT_TAKEN, this.NOT_CONFORM, this.ADMITED, this.ANALYZING, this.REPORTED,
				this.ANALYZED ];
	},
	valuesTask : function() {
		return [ this.ASIGNED, this.SAMPLE_ELEMENT_CHECKED, this.TAKEN_NOT_SIGNED, this.TAKEN, this.NOT_TAKEN ];
	},
	valuesReceive : function() {
		return [ this.TAKEN, this.ADMITED, this.NOT_CONFORM ];
	},
	valuesAnalyze : function() {
		return [ this.ADMITED, this.ANALYZING, this.ANALYZED ];
	}
};

var SAMPLE_EVENT = {
	CREATE : {
		id : 0,
		name : 'Creada',
		enumName : 'CREATE',
		className : 'eventCreate',
		icon : 'fa-snowflake-o'
	},
	CLONE : {
		id : 1,
		name : 'Clonada',
		enumName : 'CLONE',
		className : 'eventClone',
		icon : 'fa-snowflake-o'
	},
	SCHEDULE : {
		id : 2,
		name : 'Programada',
		enumName : 'SCHEDULE',
		className : 'eventSchedule',
		icon : 'fa-calendar'
	},
	ASSIGN : {
		id : 3,
		name : 'Asignada',
		enumName : 'ASSIGN',
		className : 'eventAsigned',
		icon : 'fa-address-card'
	},
	READY_TO_SAMPLING : {
		id : 4,
		name : 'Elementos de muestreo confirmados',
		enumName : 'READY_TO_SAMPLING',
		className : 'eventreadyToSampling',
		icon : 'fa-check-square-o'
	},
	TAKE_SAMPLE : {
		id : 5,
		name : 'Tomada',
		enumName : 'TAKE_SAMPLE',
		className : 'eventTake',
		icon : 'fa-tasks'
	},
	UPDATE_TAKE_SAMPLE : {
		id : 6,
		name : 'Actualiza toma',
		enumName : 'UPDATE_TAKE_SAMPLE',
		className : 'eventUpdateTakeSample',
		icon : 'fa-tasks'
	},
	SAMPLE_NONCONFORMING : {
		id : 7,
		name : 'No Conforme',
		enumName : 'SAMPLE_NONCONFORMING',
		className : 'eventNonconforming',
		icon : 'fa-snowflake-o'
	},
	SAMPLE_NONTAKEN : {
		id : 8,
		name : 'No tomada',
		enumName : 'SAMPLE_NONTAKEN',
		className : 'eventNonTaken',
		icon : 'fa-user-times'
	},
	ADMIT : {
		id : 9,
		name : 'Admitida',
		enumName : 'ADMIT',
		className : 'eventAdmit',
		icon : 'fa-exchange'
	},
	ANALYZE : {
		id : 10,
		name : 'Analizada',
		enumName : 'ANALYZE',
		className : 'eventAnalyze',
		icon : 'fa-eyedropper'
	},
	UPDATE_ANALIZE : {
		id : 11,
		name : 'Actualiza análisis',
		enumName : 'UPDATE_ANALIZE',
		className : 'eventUpdateAnalize',
		icon : 'fa-eyedropper'
	},
	REPORT : {
		id : 12,
		name : 'Reportada/Finalizada',
		enumName : 'REPORT',
		className : 'eventReport',
		icon : 'fa-snowflake-o'
	},
	CANCEL : {
		id : 13,
		name : 'Cancelada',
		enumName : 'CANCEL',
		className : 'eventCancel',
		icon : 'fa-snowflake-o'
	},
	UPDATE_SAMPLE : {
		id : 14,
		name : 'Muestra actualizada',
		enumName : 'UPDATE_SAMPLE',
		className : 'eventUpdateSample',
		icon : 'fa-snowflake-o'
	},
	TAG_SAMPLE : {
		id : 15,
		name : 'Asigna Tag',
		enumName : 'TAG_SAMPLE',
		className : 'eventTag',
		icon : 'fa-tag'
	},
	ANALYZED : {
		id : 16,
		name : 'Analisis finalizados',
		enumName : 'ANALYZED',
		className : 'eventAnalyzed',
		icon : 'fa-tag'
	},
	ADD_SAMPLE_ANALYSIS : {
		id : 100,
		name : 'Adiciona análisis',
		enumName : 'ADD_SAMPLE_ANALYSIS',
		className : 'eventAddSampleAnalysis',
		icon : 'fa-eyedropper'
	},
	UPDATE_SAMPLE_ANALYSIS : {
		id : 101,
		name : 'Actualiza análisis',
		enumName : 'UPDATE_SAMPLE_ANALYSIS',
		className : 'eventUpdateSampleAnalysis',
		icon : 'fa-eyedropper'
	},
	REMOVE_SAMPLE_ANALYSIS : {
		id : 102,
		name : 'Borra análisis',
		enumName : 'REMOVE_SAMPLE_ANALYSIS',
		className : 'eventRemoveSampleAnalysis',
		icon : 'fa-eyedropper'
	},
	values : function() {
		return [ this.CREATE, this.CLONE, this.SCHEDULE, this.ASSIGN, this.READY_TO_SAMPLING, this.TAKE_SAMPLE, this.UPDATE_TAKE_SAMPLE, this.SAMPLE_NONCONFORMING, this.SAMPLE_NONTAKEN, this.ADMIT, this.ANALYZE,
				this.REPORT, this.CANCEL, this.UPDATE_SAMPLE, this.TAG_SAMPLE, this.ANALYZED, this.ADD_SAMPLE_ANALYSIS, this.UPDATE_SAMPLE_ANALYSIS, this.REMOVE_SAMPLE_ANALYSIS ];
	}
};

var FREQUENCY = {
	DAYLY : {
		id : 1,
		name : 'Diario',
		enumName : 'DAYLY'
	},
	WEEKLY : {
		id : 2,
		name : 'Semanal',
		enumName : 'WEEKLY'
	},
	BIWEEKLY : {
		id : 3,
		name : 'Quincenal',
		enumName : 'BIWEEKLY'
	},
	MONTHLY : {
		id : 4,
		name : 'Mensual',
		enumName : 'MONTHLY'
	},
	BIMONTHLY : {
		id : 5,
		name : 'Bimensual',
		enumName : 'BIMONTHLY'
	},
	QUARTERLY : {
		id : 6,
		name : 'Trimestral',
		enumName : 'QUARTERLY'
	},
	BIANNUAL : {
		id : 7,
		name : 'Semestral',
		enumName : 'BIANNUAL'
	},
	ANNUAL : {
		id : 8,
		name : 'Anual',
		enumName : 'ANNUAL'
	},
	values : function() {
		return [ this.DAYLY, this.ANNUAL, this.BIANNUAL, this.QUARTERLY, this.BIMONTHLY, this.MONTHLY, this.BIWEEKLY, this.WEEKLY ];
	}
};

var REPORT_STATE = {
	CANCEL : {
		id : 0,
		name : 'Cancelado',
		enumName : 'CANCEL'
	},
	ACTIVE : {
		id : 1,
		name : 'Activo',
		enumName : 'ACTIVE'
	},
	values : function() {
		return [ this.CANCEL, this.ACTIVE];
	}
};

// *************************************************************************
/**
 * Return a constant
 * 
 * @param constantName
 * @param id
 * @returns {*}
 */
var getConstantById = function(constantArray, id) {
	var values = constantArray.values();

	for (var i = 0; i < values.length; i++) {
		if (values[i].enumName === id) {
			return values[i];
		}
	}
	return null;
};

/**
 * Return a constant name
 * 
 * @param constantName
 * @param id
 * @returns {*}
 */
var getConstantNameById = function(constantArray, id) {
	var constant = getConstantById(constantArray, id);
	if (constant != undefined)
		return constant.name;
	return 'Error, constant undefined';
};

/**
 * Return a constant id
 * 
 * @param constantName
 * @param id
 * @returns {*}
 */
var getConstantId = function(constantArray, id) {
	var constant = getConstantById(constantArray, id);
	if (constant != undefined)
		return constant.id;
	return 'Error, constant undefined';
};

var getValuesOrderByName = function(constantArray) {
	var constants = constantArray.values();
	constants = constants.sort(function(a, b) {
		return a.name.localeCompare(b.name);
	});
	return constants;
};

var getConstantByName = function(constantArray, name) {
	var constants = constantArray.values();
	return constants.find(function(c) {
		return c.name == name;
	});
};
